import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQSection() {
  const { t } = useTranslation('home');
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs: FAQItem[] = [
    {
      question: '开云体育平台提供哪些体育赛事资讯？',
      answer: '开云体育平台覆盖足球、篮球、网球、电竞、赛车等全球30多项热门体育赛事，提供实时比分、赛程安排、赛果查询、专业数据分析及深度赛事报道。我们的编辑团队全天候更新赛事资讯，确保您不错过任何精彩瞬间。无论您是关注欧洲五大联赛、NBA、大满贯网球还是电竞赛事，开云体育都能为您提供最全面的赛事服务。',
    },
    {
      question: '如何在开云体育平台查看赛事直播？',
      answer: '在开云体育平台，您可以通过赛事分类页面选择您关注的体育项目，进入对应分类后即可查看正在进行的赛事直播信息。平台提供实时比分更新和文字直播服务，让您随时随地掌握比赛动态。我们还提供赛程提醒功能，帮助您提前规划观赛时间。',
    },
    {
      question: '开云体育的资讯更新频率如何？',
      answer: '开云体育的编辑团队实行7×24小时轮值制度，确保全球各大体育赛事的最新动态能够在第一时间呈现在平台上。重大赛事期间，我们将提供实时滚动更新，让您不错过每一个关键进球、每一次重要判罚和每一场焦点对决。',
    },
    {
      question: '开云体育平台是否免费使用？',
      answer: '是的，开云体育平台的基础赛事资讯服务完全免费。您可以在平台浏览所有赛事资讯、查看实时比分和赛程安排。我们致力于为体育爱好者提供最优质的服务体验，让更多人能够享受体育竞技的魅力。',
    },
    {
      question: '如何联系开云体育客服？',
      answer: '您可以通过以下方式联系我们的客服团队：发送邮件至 service@kaiyunsports.com，或拨打客服热线 400-888-9999。我们的客服团队服务时间为周一至周日 9:00 - 21:00，我们将竭诚为您解答关于开云体育平台的任何问题。',
    },
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('faq_title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">{t('faq_subtitle')}</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer group"
              >
                <span className="font-heading font-semibold text-sm md:text-base text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div
                  className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-all duration-300 ${
                    openIndex === index
                      ? 'bg-primary-500 text-background-50 rotate-45'
                      : 'bg-background-200 text-foreground-500 group-hover:bg-primary-100 group-hover:text-primary-600'
                  }`}
                >
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}